module.exports = __webpack_public_path__ + "img/adas-hil-6.c72b3a97.svg";